module.exports = __webpack_public_path__ + "static/media/fire-protection.89552dce.jpg";